import { render, staticRenderFns } from "./skus.vue?vue&type=template&id=d0629fb8&scoped=true&"
import script from "./skus.vue?vue&type=script&lang=js&"
export * from "./skus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0629fb8",
  null
  
)

export default component.exports